import React from 'react';
import styled from 'styled-components';
import NextPageIcon from '../../assets/icons/double-down-w.svg';
import FlatButton from '../common/FlatButton';

const Button = styled(FlatButton)`
  height: ${({theme}) => theme.spacingVertical(4)};
  margin: ${({theme}) => theme.spacingVertical(-1)} 0 ${({theme}) => theme.spacingVertical(-2)};
  align-self: center;
  visibility: ${({hide}) => (hide ? 'hidden' : 'visible')};
`;

const Icon = styled.img`
  height: ${({theme}) => theme.spacingVertical(2)};
`;

const NextPageButton = props => (
  <Button {...props}>
    <Icon src={NextPageIcon} />
  </Button>
);

export default NextPageButton;
